module.exports = __webpack_public_path__ + "img/logo-vlex-azul.a04078f9.png";